/**
 * Fetch API package version once per browser session (hard refresh resets).
 * Concurrent callers share the same in-flight request — no interval polling.
 */
let cachedVersion: string | null | undefined;
let inflight: Promise<string | null> | null = null;

function parseVersion(data: unknown): string | null {
  if (typeof data !== "object" || data === null) {
    return null;
  }
  const version = Reflect.get(data, "version");
  if (typeof version === "string" && version.length > 0) {
    return version;
  }
  return null;
}

export function fetchApiVersion(apiBase: string): Promise<string | null> {
  if (cachedVersion !== undefined) {
    return Promise.resolve(cachedVersion);
  }

  if (inflight) {
    return inflight;
  }

  inflight = (async (): Promise<string | null> => {
    try {
      if (!apiBase) {
        cachedVersion = null;
        return null;
      }

      const data: unknown = await $fetch(`${apiBase}/api/public/version`);
      cachedVersion = parseVersion(data);
      return cachedVersion;
    } catch {
      cachedVersion = null;
      return null;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}
